<template>
  <div v-if="valueModel">
    <div v-if="props.label" class="form-label">{{ props.label }} {{ props.required ? '*' : '' }}</div>
    <div :class="{'is-invalid': errorMessage}" :title="props.title">
      <input type="radio" class="btn-check" :name="valueKey" :id="`${valueKey}-${inverseOrder ? 'true' : 'false'}`" autocomplete="off" v-bind:value="props.inverseOrder ? (valueAsString ? 'true' : true) : (valueAsString ? 'false' : false)" v-model="valueModel.value">
      <label class="btn me-2" :class="buttonClass" :for="`${valueKey}-${inverseOrder ? 'true' : 'false'}`">{{ props.inverseOrder ? labelTrue : labelFalse }}</label>

      <input type="radio" class="btn-check" :name="valueKey" :id="`${valueKey}-${inverseOrder ? 'false' : 'true'}`" autocomplete="off" v-bind:value="props.inverseOrder ? (valueAsString ? 'false' : false) : (valueAsString ? 'true' : true)" v-model="valueModel.value">
      <label class="btn" :class="buttonClass" :for="`${valueKey}-${inverseOrder ? 'false' : 'true'}`">{{ props.inverseOrder ? labelFalse : labelTrue }}</label>
    </div>
    <label v-if="props.subLabel">
      <small class="fst-italic text-muted">{{ props.subLabel }}</small>
    </label>
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </div>
</template>

<script setup lang="ts">
  import { useField } from 'vee-validate';
  import { computed } from 'vue';

  const model = defineModel<boolean | null>({required: false});

  const props = withDefaults(defineProps<{
    valueKey?: AllTypeKeys,
    valueAsString?: boolean,
    labelTrue: string,
    labelFalse: string,
    buttonClass?: string,
    inverseOrder?: boolean,
    subLabel?: string,
    title?: string,
    label?: string,
    required?: boolean
  }>(), {
    valueAsString: false,
    buttonClass: 'btn-outline-primary',
    inverseOrder: false,
    required: false
  });

  const { value, errorMessage } = props.valueKey !== undefined ? useField<boolean|string>(() => props.valueKey!) : {};

  const valueModel = computed(() => {
    if(props.valueKey) return value;
    else if(model.value !== undefined) return model;
    else return undefined;
  })
</script>
